import { StepData } from '../../@types/step-data';
import { GoToActionData } from '../../@types/action';
import Action, { ActionProps } from '../action';

interface GoToActionProps extends ActionProps {
  step: GoToActionData;
}

class GoToAction extends Action {
  step: GoToActionData;

  constructor(props: GoToActionProps) {
    super(props);
    this.step = props.step;
  }

  async perform(): Promise<StepData> {
    const name = this.conditionsSatisfied() ? this.stepNameTo : this.stepNameElse;
    return name ? this.steps.find((s) => s.stepName === name) : this.getNextStep();
  }

  get stepNameElse() {
    return this.step.stepNameElse;
  }

  get stepNameTo() {
    return this.step.stepNameTo;
  }
}

export default GoToAction;
